// https://regex101.com/r/0ouxZn/1
const defaultPasswordRegex = /^(?=.*\d)(?=.*[A-Za-z]).{8,}$/;

export { defaultPasswordRegex };
